<template>
  <div>
    <LayoutIntroductionHeaderComponent :page="page" />

    <PagesPressQueryComponent />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const page = baseStrapiGetAttributes(props.data)

</script>

<style module>
</style>
